import { render, staticRenderFns } from "./mobile-side-menu.vue?vue&type=template&id=93a9a048&scoped=true&"
import script from "./mobile-side-menu.vue?vue&type=script&lang=js&"
export * from "./mobile-side-menu.vue?vue&type=script&lang=js&"
import style0 from "./mobile-side-menu.vue?vue&type=style&index=0&id=93a9a048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a9a048",
  null
  
)

/* custom blocks */
import block0 from "./mobile-side-menu.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports